// extracted by mini-css-extract-plugin
module.exports = {"root":"Btn_root__1Emjc","icon":"Btn_icon__34xSQ"};